import { render, staticRenderFns } from "./cancerHelp.vue?vue&type=template&id=9b5b3618&"
import script from "./cancerHelp.vue?vue&type=script&lang=js&"
export * from "./cancerHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports